import React from 'react'

function WomanHistory() {
  return (
    <svg
      width={234}
      height={228}
      viewBox="0 0 234 228"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.339 29.455C-7.711 54.306-.142 99.358 14.847 133.714c15.077 34.29 37.596 57.951 66.802 74.561 29.206 16.609 65.034 26.303 92.223 14.536 27.189-11.767 45.608-44.864 54.563-80.978 8.959-36.181 8.332-75.318-11.038-100.3S159.949 5.794 117.981 2.776C76.111-.164 30.38 4.535 11.339 29.456z"
        fill="#F3F5F8"
      />
      <path
        d="M168.898 98.527c-.786-3.738-1.207-8.72.227-13.772l-.055-.017a4.843 4.843 0 00-1.258-.206c-1.024-.034-2.442.227-3.982 1.463a23.663 23.663 0 00-.42 1.64 28.61 28.61 0 00-.611 4.579c-.189 3.687.316 8.36 3.025 12.469l.01.006c.07.037.176.091.315.151.278.119.681.261 1.174.343.898.15 2.102.108 3.417-.632a28.671 28.671 0 01-.531-1.37 35.679 35.679 0 01-1.311-4.654z"
        fill="#E5E5E5"
        stroke="#E5E5E5"
      />
      <path
        d="M180.565 91.238h-.001c-.479-.76-1.371-1.54-2.494-2.292-1.113-.745-2.41-1.434-3.65-2.022a51.144 51.144 0 00-4.273-1.787c-2.869 5.29-2.494 10.057-1.386 13.536a19.087 19.087 0 001.949 4.227 16.066 16.066 0 00.986 1.415 4.999 4.999 0 011.467.744c.841.62 1.722 1.69 1.905 3.445v.001c.313 3.069-.487 8.438-2.117 14.168-1.634 5.743-4.125 11.931-7.247 16.642-.983 1.506-2.344 1.906-3.438 1.919a5.234 5.234 0 01-1.743-.283 15.702 15.702 0 00-1.6.624 19.114 19.114 0 00-3.978 2.428c-2.862 2.276-5.834 6.036-6.391 12.041l.001.001a49.216 49.216 0 004.57 1.032c1.354.234 2.807.414 4.138.432 1.344.019 2.506-.127 3.312-.501l.001-.001c3.866-1.784 7.58-5.941 10.858-11.402 3.269-5.444 6.064-12.116 8.123-18.833 2.365-7.83 3.773-14.907 4.006-20.94.234-6.038-.71-10.983-2.998-14.594z"
        fill="#E5E5E5"
        stroke="#E5E5E5"
      />
      <path
        d="M144.013 151.773c-.043.138-.075.246-.096.32.568 1.882 1.597 2.883 2.469 3.419a4.845 4.845 0 001.226.539c1.612-4.977 4.738-8.879 7.475-11.549a36.04 36.04 0 013.686-3.141c.481-.355.875-.625 1.15-.808l.061-.04c-.668-1.357-1.643-2.065-2.475-2.441a5.124 5.124 0 00-1.171-.368 4.43 4.43 0 00-.347-.049l-.013-.001c-4.552 1.913-7.581 5.522-9.477 8.696a27.933 27.933 0 00-2.034 4.149c-.21.538-.359.974-.454 1.274z"
        fill="#E5E5E5"
        stroke="#E5E5E5"
      />
      <path
        d="M78.554 86.953c.162 3.27 0 127.106 0 127.106h8.64l13.217-81.382c.167-2.638 2.576-31.806 2.576-31.806L87.776 85.245l-9.222 1.708z"
        fill="#C01414"
      />
      <path
        d="M113.476 86.07s9.9 63.339 9.9 65.917c0 2.579-16.209 61.011-16.209 61.011H98.85l7.075-67.37-24.256-56.99"
        fill="#D62929"
      />
      <path
        d="M72.278 62.108c-.452.656-3.292 7.282-3.078 9.89.33 3.99 3.067 6.197 7.75 8.618 1.347 0 2.784-15.553 2.784-15.553l-4.212-2.955h-3.245z"
        fill="#B3B3B3"
      />
      <path
        d="M81.669 44.804c-6.307 4.872-11.656 14.463-10.616 16.229.499.825 3.097 2.296 6.065 3.633"
        fill="#646363"
      />
      <path
        d="M107.423 18.832c1.835-7.51-1.474-14.77-7.39-16.215-5.916-1.445-12.2 3.47-14.034 10.98-1.835 7.51 1.474 14.77 7.39 16.215 5.916 1.445 12.199-3.47 14.034-10.98z"
        fill="#B3B3B3"
      />
      <path
        d="M96.015 32.708c14.027 0 19.757 50.297 17.456 53.365-3.14 4.184-25.603 7.553-34.912.883-3.58-2.556-4.124-54.248 17.456-54.248z"
        fill="#4D4D4D"
      />
      <path
        d="M115.909 58.892c.394.419 3.803 5.394 4.28 6.456.95-.81 31.46-26.39 31.961-26.737.501-.347 1.369-.317 1.708-.087a1.343 1.343 0 01.467 1.72c-.27.499-4.063 3.835-4.063 3.835.31.387 1.893 4.402-.134 6.287-1.379 1.284-2.943 1.71-4.447.915-.997 1.08-24.842 27.43-29.001 27.43-1.925 0-8.528-6.775-11.506-11.88"
        fill="#B3B3B3"
      />
      <path
        d="M94.828 47.664c0 8.23 6.483 19.7 8.728 19.7 2.244 0 13.466-8.229 13.466-10.224 0-1.995-8.728-16.707-16.209-16.707-2.993 0-5.985 3.241-5.985 7.231z"
        fill="#646363"
      />
      <path
        d="M94.08 14.75c4.299.032 12.104-8.401 12.104-8.728 0-.748-1.326-4.7-9.025-4.7-5.498 0-14.149 3.85-14.149 16.495 0 6.511-2.546 13.466-2.546 16.608 0 4.775 3.848 7.785 9.925 7.785 2.935 0 7.35-1.446 7.35-3.82 0-3.471 3.56-14.75-3.243-17.207"
        fill="#000"
      />
      <path
        d="M95.272 20.84a2.534 2.534 0 01-1.37.409c-1.553 0-2.812-1.456-2.812-3.254s1.26-3.242 2.813-3.242c.29 0 .58.05.853.15"
        fill="#B3B3B3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M106.555 15.367a.307.307 0 00-.131.414l.086.158c.153.277.39.707.486 1.141.057.26.052.476-.02.639-.066.148-.21.3-.545.397a.307.307 0 00.17.59c.47-.136.781-.391.935-.738.148-.333.129-.7.058-1.02-.118-.535-.415-1.07-.562-1.334l-.064-.116a.306.306 0 00-.413-.13zM103.704 18.925a.306.306 0 00-.123.415 3.8 3.8 0 00.684.89c.258.248.581.482.902.535a.306.306 0 00.1-.605c-.13-.021-.34-.144-.577-.373a3.185 3.185 0 01-.57-.739.307.307 0 00-.416-.123z"
        fill="#1F161E"
      />
      <ellipse cx={102.518} cy={14.751} rx={0.444} ry={0.889} fill="#0D0D0D" />
      <path
        d="M100.748 19.194c.981 0 1.777-.398 1.777-.889 0-.49-.796-.888-1.777-.888-.982 0-1.777.398-1.777.888 0 .491.795.889 1.777.889z"
        fill="#FA9E9F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M154 17.001c0-8.25 6.75-15 15-15s15 6.75 15 15-6.75 15-15 15-15-6.75-15-15zm14.205 1.935l6.12 3.765c.54.33 1.245.165 1.575-.36.33-.54.15-1.245-.39-1.575l-5.76-3.465v-6.675c0-.615-.51-1.125-1.125-1.125s-1.125.51-1.14 1.125v7.035c0 .525.27 1.005.72 1.275z"
        fill="#4D4D4D"
      />
      <path
        d="M78.554 214.058V220H98.85v-3.356l-11.655-2.586M98.85 212.999v7.002h21.256v-2.723l-12.93-4.279"
        fill="#000"
      />
    </svg>
  )
}

export default React.memo(WomanHistory)
